import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-td",
  "use": "icon-icon-td-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-td\">\n  <g fill-rule=\"evenodd\">\n    <path fill=\"#002664\" d=\"M0 0h171.2v512H0z\" />\n    <path fill=\"#c60c30\" d=\"M340.8 0H512v512H340.8z\" />\n    <path fill=\"#fecb00\" d=\"M171.2 0h169.6v512H171.2z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol